import { render, staticRenderFns } from "./MarkerTagsSelector.vue?vue&type=template&id=483e64de"
import script from "./MarkerTagsSelector.vue?vue&type=script&lang=js"
export * from "./MarkerTagsSelector.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MarkerTagsSelector.vue?vue&type=style&index=1&id=483e64de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports